/**
 * @file index.tsx
 *
 * @fileoverview Renders the appropriate component for usage with autocompletes.
 */
import { JobsSearchInputForm } from '~/jobiqo/components/JobSearch/components/SearchInputForm';
export { JobsSearchInputForm as JobSearchForm };
export default JobsSearchInputForm;
